import styled from 'styled-components'
import colors from '../../../assets/colors'

const BoxStyled = styled.div`
  .grid-container {
    background: #FFFFFF;
    box-shadow: 0px 4px 6px rgba(98, 102, 113, 0.06), 0px 2px 2px rgba(98, 102, 113, 0.06);
    border-radius: 6px;
    padding: 20px 30px;
  }

  .passed {
      color: green;
    }
  .failed {
    color: orangered;
  }
    
    

  @media print {
    .header-table {
      background: ${colors.white} !important;
      -webkit-print-color-adjust: exact;

      p {
        color: ${colors.white} !important;
      }
    }

    && {
      padding: 30px 24px !important;
    }
  }

  && {
    border-radius: 8px;
    padding-top: 24px;

    .ia-summary {
      font-size: 14px;
      line-height: 1.5;
      text-align: justify;
      
      white-space: pre-line;
    }
    
    .ia-criteria {
      border: 1px solid #d3d3d3;
      border-radius: 8px;
      margin: 2rem;
      padding: 1rem;
      box-shadow: 0 2px 4px -2px #ddd;
      color: #333;
      font-size: 14px;
      
      h5 {
        color: inherit;
        font-weight: 600;
        font-size: 16px;
        background: #eee;
        padding: 0.6rem;
        margin-left: -1rem;
        border-radius: 8px 8px 0 0;
        margin-right: -1rem;
        margin-top: -1rem;
      }
      
      &.passed h5 {
        color: green;
      }
      &.failed h5 {
        color: orangered;
      }
    }
  }
`

export default BoxStyled
